import { render, staticRenderFns } from "./About.vue?vue&type=template&id=5039a2a0&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5039a2a0')) {
      api.createRecord('5039a2a0', component.options)
    } else {
      api.reload('5039a2a0', component.options)
    }
    module.hot.accept("./About.vue?vue&type=template&id=5039a2a0&", function () {
      api.rerender('5039a2a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/pages/About.vue"
export default component.exports